export default __webpack_public_path__ + "static/media/policy04_2023.e8dbbc6b.jpg";